import React from 'react';
import PropTypes from 'prop-types';

/**
 * Inline error summary for a single rule. Rendered inside RuleCard when
 * `errors` is non-empty. `aria-live="polite"` so screen readers announce
 * new errors without interrupting the user's typing.
 */
export default function RuleValidationSummary({ errors, ruleIndex }) {
	if (!errors) return null;

	const messages = [];

	(errors.general || []).forEach((m) => messages.push(m));

	if (errors.ifConditions) {
		Object.entries(errors.ifConditions).forEach(([idx, msgs]) => {
			msgs.forEach((m) => messages.push(`IF condition #${Number(idx) + 1}: ${m}`));
		});
	}

	const branchSummary = (bucket, label) => {
		if (!bucket) return;
		Object.entries(bucket).forEach(([fieldName, byKey]) => {
			Object.entries(byKey).forEach(([constraintKey, msgs]) => {
				msgs.forEach((m) => {
					messages.push(`${label} "${fieldName}" (${constraintKey}): ${m}`);
				});
			});
		});
	};
	branchSummary(errors.thenFields, 'THEN');
	branchSummary(errors.elseFields, 'ELSE');

	if (messages.length === 0) return null;

	return (
		<div
			className="dsv-xallof-builder__validation-summary"
			role="alert"
			aria-live="polite"
			data-testid={`xallof-rule-${ruleIndex}-validation-summary`}
		>
			<ul>
				{messages.map((m, i) => (
					<li key={i}>{m}</li>
				))}
			</ul>
		</div>
	);
}

RuleValidationSummary.propTypes = {
	errors: PropTypes.object,
	ruleIndex: PropTypes.number.isRequired,
};
